import React from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumb_comp from '../common_component/breadcrumb-comp/Breadcrumb_comp';
import Product_details_slider from './product_details_slider/Product_details_slider';
import Product_details_tab from './product_details_tab/Product_details_tab';
import productData from '../products/productData/ProductData';

function Product_details() {
    const { productId } = useParams();
    const product = productData.find(p => p.id === productId);

    if (!product) return <div className="container">Product not found.</div>;

    return (
        <section className='Product_details'>
            <div className="container">
                <Breadcrumb_comp
                    breadcrumbs={[
                        { label: "Home", link: "/", isActive: false },
                        { label: "Product", link: "/products", isActive: false },
                        { label: product.title, link: "", isActive: true },
                    ]}
                />

                <Product_details_slider images={product.relatedImages} title={product.title}  types={product.types}/>
                <Product_details_tab details={product.details} />
            </div>
        </section>
    );
}

export default Product_details;
